module.exports = __webpack_public_path__ + "static/img/5.bb51c8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/sp/5.png
// module id = h8Sx
// module chunks = 0